import React, {useState} from 'react';
import {
  Button,
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import {BaseFullPage} from '../base';
import {DemoLoginCountry, demoLoginCountries} from './demoLoginCountry';

export const LoginDemoHome = () => {
  const navigate = useNavigate();
  const [country, setCountry] = useState<DemoLoginCountry>('SE');
  const handleLoginClick = () => {
    navigate(`/demo?country=${country}`);
  };

  return (
    <BaseFullPage id={'login_demo_home'}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 3,
          minHeight: '50vh',
        }}>
        <Typography variant="h4" component="h1">
          {'Demo Login'}
        </Typography>

        <Typography variant="body1" color="text.secondary">
          {'Choose a country and start the demo login.'}
        </Typography>

        <ToggleButtonGroup
          exclusive
          value={country}
          aria-label={'Country'}
          onChange={(_, value: DemoLoginCountry | null) => {
            if (value) setCountry(value);
          }}>
          {(Object.keys(demoLoginCountries) as DemoLoginCountry[]).map(
            (code) => (
              <ToggleButton key={code} value={code}>
                {demoLoginCountries[code].label}
              </ToggleButton>
            ),
          )}
        </ToggleButtonGroup>

        <Button
          variant="contained"
          size="large"
          onClick={handleLoginClick}
          sx={{minWidth: 200}}>
          {'Start Demo Login'}
        </Button>
      </Box>
    </BaseFullPage>
  );
};
